module.exports = __webpack_public_path__ + "static/media/9DESA28.44a3ba81.jpg";